// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__290xz","checkboxCol":"Table_checkboxCol__2lPa5","emailCol":"Table_emailCol__1xqxF","actionCol":"Table_actionCol__t2mQG"};